import { render, staticRenderFns } from "./orderDatalis.vue?vue&type=template&id=69166d1e&scoped=true"
import script from "./orderDatalis.vue?vue&type=script&lang=js"
export * from "./orderDatalis.vue?vue&type=script&lang=js"
import style0 from "./orderDatalis.vue?vue&type=style&index=0&id=69166d1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69166d1e",
  null
  
)

export default component.exports